
export const statusConfigValues = {
  Ok: 0,
  ShowLogin: 1,
  ShowPassword: 2,
  ShowLoginExecution: 3,
}

export const typeFile = {
  PDF: { id: 0, name: 'pdf' },
  XLS: { id: 1, name: 'xls' },
  HTML: { id: 2, name: 'html' },
  DOC: { id: 3, name: 'doc' },
}

export const typeFilter = {
  current: 'Current',
  bySession: 'bySession',
  byPeriod: 'byPeriod',
  byMachine: 'byMachine',
  byUser: "byUser",
  byCashier: "byCashier",
  Paid: "Paid",
  Opened: "Opened",
  Expired: "Expired",
}

export const classValue = {
  none: 0,
  approved: 1,
  warning: 2,
  error: 3,
  info: 4,
}

export const clientOptions = {
  block: 1,
  unblock: 2,
  delete: 3,
  recover: 4,
}

export const clientStatus =
  [
    {
      name: "activeClients", value: 0
    },
    {
      name: "inactiveClients", value: 1
    },
    {
      name: "blockedClients", value: 2
    },
    {
      name: "deletedClients", value: 3
    },
    {
      name: "noCommunicationClients", value: 5
    },
    {
      name: "All", value: 4
    },
  ]

  export const listClients =
  [
    {
      name: "All", value: 0
    },
    {
      name: "Sirius Server (ALL)", value: 99
    },
    {
      name: "Sirius Server (FBM)", value: 1
    },
    {
      name: "Sirius Server (DINGO)", value: 3
    },
    {
      name: "System Server", value: 2
    },
  ]

export const wifiStrength = {
  strength0: 0,
  strength1: 1,
  strength2: 2,
  strength3: 3,
  strength4: 4,
}

export const gameType = {
  bingo: 0,
  spin: 1,
}

export const typesModules = {
  prog: 0,
  multi: 1,
  mystery: 2,
  pigBoom: 3
}

export const loggedStatus = {
  NOT_LOGGED: 0,
  LOGGED: 1,
}

export const returnBlockMachines = {
  SERVER_ERROR: 'SERVER_ERROR',
  MACH_ERROR: 'MACH_ERROR',
  IN_BONUS: 'IN_BONUS',
}

export const typeCSVFilter = {
  Final: 0,
  Partial: 1,
  BySession: 2,
}

export const terminalOptions = {
  payment: 0,
  delete: 1,
  open: 2,
  moveTerminal: 3,
  none: 255,
}

export const sessionControl = {
  manual: 0,
  automatic: 1,
  semiAutomatic: 2,
}

export const ticketStatus = {
  Paid: 0,
  ToPay: 1,
}

export const machineOperation = {
  LogOff: 0,
  ForcedLogOff: 1,
  Restart: 2,
  Shutdown: 3,
}

export const globalType = {
  ClientOnly: 0,
  ServerOnly: 1,
  ClientAndServer: 2,
  None: 3,
}

export const permissionLevel = {
  Root: 6,
  Watcher: 5,
  Tech: 4,
  Manager: 3,
  Cashier: 2,
  Report: 1,
}

export const resetType ={
  PaymentNoConnection: 0,
  AdjustmentValue: 1,
}

export const megapotConnStatus =
[
  {
    name: "Connected", value: 0
  },
  {
    name: "No Communication", value: 1
  },
  {
    name: "Disconnected", value: 2
  },
  {
    name: "All", value: 255
  }  
]

export function getPermissionLevel(user) {
  if (user.Root) {
    return permissionLevel.Root
  } else if (user.Technician) {
    return permissionLevel.Tech
  } else if (user.Manager) {
    return permissionLevel.Manager
  } else if (user.Cashier) {
    return permissionLevel.Cashier
  } else if (user.ReportView) {
    return permissionLevel.Report
  } else if(user.Watcher){
    return permissionLevel.Watcher
  }
}

export function
  getUserPermissions(countries, countryCode, page, userLogged, userAux) {
    let options = []
    const lvl = getPermissionLevel(userLogged)
    let option = {}
    if (lvl == permissionLevel.Root && (!userAux.Technician && !userAux.Cashier && !userAux.ReportView && !userAux.Manager)) {
      option = {
        name: page.translate("root_Option"),
        code: "root",
      }
      options.push(option)
    }

    if (lvl >= permissionLevel.Tech && !userAux.Root) {
      option = {
        name: page.translate("technician_Option"),
        code: "technician",
      }
      options.push(option)
    }
    
    if (countries.Philippines == countryCode && !userAux.Root) {
      options.push({
        name: page.translate("reportView_Option"),
        code: "reportView",
      })
    }

    if (lvl >= permissionLevel.Watcher && !userAux.Root) {
      option = {
        name: page.translate("watcher_Option"),
        code: "watcher",
      }
      options.push(option)
    }
    return options;
  }

export default { clientStatus, statusConfigValues, typeFile, typeFilter, classValue, typesModules, loggedStatus, returnBlockMachines, typeCSVFilter, terminalOptions, sessionControl, machineOperation, ticketStatus, globalType, getUserPermissions, wifiStrength, getPermissionLevel, resetType, listClients, gameType, megapotConnStatus }
